import type { Course } from '@/models/catalog/course';
import { formatDuration } from '@/utils/masks/time';

export type CourseOption = {
  id: number;
  label: string;
  offerId: number;
  courseType: {
    type: string;
    label: string;
  };
  modality: {
    type: string;
    label: string;
  };
  rawCourse: Course;
};

export const formatCourseLabel = (course: Course) => {
  const formattedDuration = formatDuration(
    course.duration.type,
    course.duration.quantity
  );
  return `${course.course_name}, ${course.course_type.label}, ${formattedDuration}, ${course.modalities.map(({ label }) => label).join(',')}`;
};

export const mountCourseOptions = (courses: Course[]): CourseOption[] =>
  courses?.map((course) => {
    const label = formatCourseLabel(course);

    return {
      courseType: course.course_type,
      id: course.id,
      label,
      modality: course.modalities[0],
      offerId: course.offer_id,
      rawCourse: course,
    };
  });
